import React from "react";
import OkendoStarRating from "components/okendo/star-rating";
import { scrollToElementById } from "helpers/scroll";
import { reviewsWidgetId } from "utils/constants";
import clsx from "clsx/lite";
import { useSettings } from "hooks/useStore";
import useIsSticky from "hooks/useIsSticky";
import { useMediaQuery } from "react-responsive";
import { SCREEN_SIZES } from "utils/constants";
import { sortTabs } from "helpers/tabs";

const StickyActionBar = ({ product, productTabs }) => {
	const { updateActiveTab, isClient } = useSettings(["updateActiveTab", "isClient"]);

	const { title, type, reviewAggregate, id: productId } = product;
	const isSticky = useIsSticky({ triggerOnBothWays: true, threshold: 900 });

	const isMobile = useMediaQuery({ maxWidth: SCREEN_SIZES.md });
	if (isMobile || !isClient) return null;

	const handleTabClick = (tab, index) => {
		updateActiveTab(productId, index);
		scrollToElementById("tabs", 250);
	};

	const sortedTabs = sortTabs(productTabs || []);

	return (
		<div
			className={clsx(
				"hidden flex-col !z-50 w-full",
				isSticky ? "sticky-element !flex h-0" : "sticky-element-hidden absolute"
			)}
		>
			<div className="bg-cream">
				<div className="max-w-screen-xl mx-auto flex justify-between items-center px-6 py-1 w-full">
					<div className="w-1/2">
						<div className="flex items-center py-4 gap-8">
							<h4 className="font-bold md:font-medium text-start md:pr-8 border-r-2">{title}</h4>
							<div className="flex flex-col justify-center ">
								<p className="text-secondary uppercase text-sm">{type}</p>
							</div>
						</div>
					</div>
					<div className="w-1/2">
						<button
							onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
							className="btn-secondary text-sm tracking-widest h-10 min-w-80 w-auto min-h-fit ml-auto">
							Shop {title}
						</button>
					</div>
				</div>
			</div>
			<div className="border-b shadow-xl bg-white">
				<div className="flex px-6 py-2 w-full gap-7 max-w-screen-xl mx-auto">
					{sortedTabs?.map((tab, index) => (
						<button
							key={tab._key}
							onClick={() => handleTabClick(tab, index)}
							className="text-sm"
						>

							{tab.title}
						</button>
					))}

					<button className="text-sm flex gap-2" onClick={() => scrollToElementById(reviewsWidgetId, 300)}>
						Reviews <OkendoStarRating reviewAggregate={reviewAggregate} />
					</button>
				</div>
			</div>
		</div>
	);
};

export default StickyActionBar;
